import type { InvoiceStatus } from "@shared/types";

const labels: Record<InvoiceStatus, string> = {
  draft: "Koncept",
  issued: "Vystavená",
};

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  return <span class={`badge badge--${status}`}>{labels[status]}</span>;
}
